import { FeatureFilterItemType } from './FeatureFilterItemType';

export default interface CapabilityFilter {
    filterName: CapabilityFilterType;
    filterValue: string | string[] | FeatureFilterItemType[];
}

export enum CapabilityFilterType {
    Capacity,
    Feature,
    Tag,
    Floor,
}

export interface RoomListCapabilityProps {
    maxCapacity: number;
    minFloor: number;
    maxFloor: number;
    hasFeatures: boolean[];
    hasTags: boolean;
}
